import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, addRow, history }) => {
    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table
                        className="assessment-table inspn-assessment-table"
                        cellSpacing={0}
                    >
                        <tbody>
                            <tr className="bghed">
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s2 pd10 w150">
                                    <p>Date Audited</p>
                                </td>
                                <td className="hd-s2 pd10 w200">
                                    <p>(P) VO number</p>
                                </td>
                                <td className="hd-s2 pd10 w200">
                                    <p>Originator Yard/Owner



                                    </p>
                                </td>

                                <td className="hd-s2 pd10 w200">
                                    <p>Subject





                                    </p>
                                </td>

                                <td className="hd-s2 pd10 w200">
                                    <p>Est Cost in USD



                                    </p>
                                </td>

                                <td className="hd-s2 pd10 w200">
                                    <p>Approved date



                                    </p>
                                </td>


                                <td className="hd-s2 pd10 w200">
                                    <p>Agreed Cost in USD





                                    </p>
                                </td>
                                <td className="hd-s2 pd10 w200">
                                    <p>Time Impact (in days)





                                    </p>
                                </td>
                                <td className="hd-s2 pd10 w200">
                                    <p>Remarks



                                    </p>
                                </td>

                            </tr>

                            {state.map((item, index) => {
                                const selectedOption = item.form.options.find(opt => opt.ID == item.form.value);
                                return (
                                    <tr key={index}>
                                        <td className="td-s1">
                                            <p className="s1">{index + 1}.</p>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control"
                                                name={item.date_audited.name}
                                                value={item.date_audited.value}
                                                onChange={(e) => onChange(item.date_audited.name, e.target.value, index)}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <select
                                                className="form-control"
                                                name={item.form.name}
                                                value={item.form.value}
                                                onChange={(e) => onChange(item.form.name, e.target.value, index)}
                                            >
                                                <option value="">Select (P) VO number</option>
                                                {item.form.options.map((form) => (
                                                    <option key={form.ID} value={form.ID}>{form.ID}</option>
                                                ))}
                                            </select>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Autofill"
                                                value={
                                                    selectedOption
                                                        ? `${selectedOption.YARD_NAME || ''}/${selectedOption.HULL_NUMBER || ''}`
                                                        : ''
                                                }
                                                readOnly
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Autofill"
                                                value={selectedOption?.SUBJECT || ''}
                                                readOnly
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Estimated Cost"
                                                name={item.estimated_cost.name}
                                                value={item.estimated_cost.value}
                                                onChange={(e) => onChange(item.estimated_cost.name, e.target.value, index)}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control"
                                                placeholder="Approved date"
                                                name={item.approved_date.name}
                                                value={item.approved_date.value}
                                                onChange={(e) => onChange(item.approved_date.name, e.target.value, index)}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Agreed Cost"
                                                name={item.agreed_cost.name}
                                                value={item.agreed_cost.value}
                                                onChange={(e) => onChange(item.agreed_cost.name, e.target.value, index)}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Time Impact"
                                                name={item.time_impact.name}
                                                value={item.time_impact.value}
                                                onChange={(e) => onChange(item.time_impact.name, e.target.value, index)}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Remarks"
                                                name={item.remarks.name}
                                                value={item.remarks.value}
                                                onChange={(e) => onChange(item.remarks.name, e.target.value, index)}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                            <tr>
                                <td colSpan={4} className="td-s1 hd-s2 pd10 pr15">
                                    <p className="text-right ">Total Cost (USD)</p>
                                    <p />
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>
                                        <span className="red">${state.reduce((sum, item) => sum + (item.agreed_cost.value || 0), 0)}</span>
                                    </p>
                                </td>
                                <td className="td-s1 pd10 hd-s2 pr15" colSpan={2}>
                                    <p className="text-right ">Total delay (days) </p>
                                </td>
                                <td className="hd-s2 pd10" colSpan={3}>
                                    <p>
                                        <span className="red">
                                            {state.reduce((sum, item) => sum + (item.time_impact.value || 0), 0)}
                                        </span>
                                    </p>
                                </td>
                            </tr>


                            <tr className="addmoreitem">
                                <td className="td-s1" colSpan={15}>
                                    <button type="button" className="btn btn-link" onClick={() => { addRow() }}>
                                        + Add New
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.siteManagement.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)